import type { DayNumberType } from '@app/components/Calendars/components/DayNumber/types';
import { Text } from '@app/components/Text';
import { emptyFn } from '@app/constants';

import '@app/components/Calendars/components/DayNumber/styles/DayNumber.desktop.scss';

export const DayNumber: DayNumberType = ({
  dayNumber,
  isToday = false,
  isDisabled = false,
  title = '',
  size = 'small',
  onClick = emptyFn,
  clickable = false,
  black = false,
  isSelectedDay = false,
  alignItems = 'center',
}) => {
  const isSmall = size === 'small';

  return (
    <div
      className={`day-number-title-container ai-${alignItems}`}
      onClick={onClick}
      data-clickable={clickable}
    >
      {title && (
        <Text
          className="week-day-title"
          fontSize={isSmall ? 14 : 20}
          lineHeight={isSmall ? 14 : 20}
          data-title-color={black ? 'black' : 'gray'}
          data-title-selected={isSelectedDay && !isToday}
        >
          {title}
        </Text>
      )}
      {dayNumber && (
        <Text
          className="header-title"
          fontSize={isSmall ? 18 : 20}
          lineHeight={isSmall ? 18 : 20}
          data-title-color={
            isSelectedDay && !isToday
              ? 'blue'
              : !isDisabled && isToday
              ? 'white'
              : isDisabled
              ? 'gray'
              : 'black'
          }
          data-title-size={size}
        >
          {dayNumber}
        </Text>
      )}
    </div>
  );
};
